import React, { Component } from 'react'

import { getProperty } from '../utils'
import { Button, Table } from '../ui'
import * as mwacPropTypes from '../propTypes'
import DroneSelectionForm from './modals/drone_selection_form'

export default class Drones extends Component {
    static propTypes = {
        appState: React.PropTypes.object,
        crew_uuid: React.PropTypes.string,
        gear: mwacPropTypes.gearWithArrayOf(mwacPropTypes.Drone),
        gearActions: React.PropTypes.object,
        modalActions: React.PropTypes.object,
        personalActions: React.PropTypes.object,
    }

    _showSelectionForm = (drone) => {
        let title = 'Add new drone'
        let data = {}

        if (drone) {
            title = 'Edit drone'
            data = drone
        }

        this.props.modalActions.showModal({
            component: (
                <DroneSelectionForm
                    crew_uuid={ this.props.crew_uuid }
                    data={ data }
                />
            ),
            modalProps: {
                allowClose: true,
                title,
            },
        })
    }

    _deleteItem = (item) => {
        this.props.gearActions.deleteDrone(this.props.crew_uuid, item.uuid)
    }

    render() {
        const key = 'drones'
        let data = []

        if (this.props.gear.data && this.props.gear.data[key]) {
            data = this.props.gear.data[key]
        }

        let errors = null

        if (getProperty(this.props.gear.errors, key)) {
            errors = (
                <div className="alert alert--error">
                    { this.props.gear.errors[key].map(
                        (item, index) => <p key={ index }>{ item }</p>
                    ) }
                </div>
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Drones
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        { errors }

                        <Table
                            columns={ [
                                { header: 'Make', key: 'make' },
                                { header: 'Model', key: 'model' },
                                { header: 'Max flight time', key: 'max_flight_time' },
                                { header: 'Max payload weight', key: 'max_payload_weight_verbal' },
                                {
                                    header: '\xa0',
                                    className: 'text-right',
                                    display: Table.deleteButton(this._deleteItem),
                                    key: 'delete',
                                },
                            ] }
                            data={ data }
                            onRowClick={ this._showSelectionForm }
                            responsive="stack"
                        />

                        <Button onClick={ () => this._showSelectionForm() } status="create">
                            Add new drone
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/drones.js